module.exports = __webpack_public_path__ + "static/media/movily3-login.d4da832b.PNG";